export enum StatusFile {
  SENT = 'ENVIADO',
  APPROVED = 'APROVADO',
  REJECTED = 'REJEITADO',
  DELETION_REQUESTED = 'REMOCAO_SOLICITADA',
  DELETED = 'REMOVIDO'
}
